import script from "./PatientGrowthChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientGrowthChart.vue?vue&type=script&setup=true&lang=js"

import "./PatientGrowthChart.vue?vue&type=style&index=0&id=fcf7be28&scoped=true&lang=css"
import "./PatientGrowthChart.vue?vue&type=style&index=1&id=fcf7be28&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcf7be28"]])

export default __exports__